import { IAnalyticsScorecard } from '@/types/analytics';
import { Get } from '../../helpers';
import filterParams from '../filter-params';

const GetEventShares = ({
  projectUuid,
  start,
  end,
  audienceLists,
  signal,
}: {
  projectUuid: string;
  start?: number;
  end?: number;
  audienceLists?: string[];
  signal?: AbortSignal;
}): Promise<IAnalyticsScorecard | null> => {
  return Get({
    path: `/v3/admin/metrics/events/${projectUuid}/shares?${filterParams({ start, end, audienceLists })}`,
    signal,
    isMetrics: true,
  });
};

export default GetEventShares;
